import { ProfissionalDeSaudeListSearchComponent } from './ProfissionalDeSaudeListSearchComponent'
import { ProfissionalDeSaudeListToolbar } from './ProfissionalDeSaudeListToolbar'

export const ProfissionalDeSaudeListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <ProfissionalDeSaudeListSearchComponent actions={<ProfissionalDeSaudeListToolbar />} />
    </div>
  )
}
